import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import SearchRequest from "../../magData/Bus/SearchRequest";
import SearchResponse from "../../magData/Bus/SearchResponse";

function BusSearchPage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Bus Search Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/bus/search</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>fromCity</td>
                  <td>fromCity</td>
                  <td>Integer</td>
                  <td><Badge bg="warning" text="dark">
                    None.
                  </Badge></td>
                </tr>
                <tr>
                  <td>toCity</td>
                  <td>toCity</td>
                  <td>Integer</td>
                  <td><Badge bg="warning" text="dark">
                    None.
                  </Badge></td>
                </tr>
                <tr>
                  <td>date</td>
                  <td>date</td>
                  <td>String</td>
                  <td><Badge bg="warning" text="dark">
                    None.
                  </Badge></td>
                </tr>
                <tr>
                  <td>passengerCount</td>
                  <td>passengerCount</td>
                  <td>Integer</td>
                  <td><Badge bg="warning" text="dark">
                    None.
                  </Badge></td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(SearchRequest, null, 2)}
            </pre>


          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>searchKey</td>
                  <td>Search Key</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>pricedItineraries</td>
                  <td>pricedItineraries</td>
                  <td>Collection of string</td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>providerOwner</td>
                          <td>
                            providerOwner
                          </td>
                          <td>Guid</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>gdsRefrenceID</td>
                          <td>
                            gdsRefrenceID
                          </td>
                          <td>Guid</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>id</td>
                          <td>
                            id
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>company</td>
                          <td>
                            company
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>operatingCompany</td>
                          <td>
                            operatingCompany
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>code</td>
                                  <td>
                                    code
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>name</td>
                                  <td>
                                    name
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>boardingPoint</td>
                          <td>
                            boardingPoint
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>city</td>
                                  <td>
                                    city
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>terminal</td>
                                  <td>
                                    terminal
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>additionalInfo</td>
                                  <td>
                                    additionalInfo
                                  </td>
                                  <td>Collection of string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>city</td>
                                          <td>
                                            city
                                          </td>
                                          <td>Collection of string</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan={4}>
                                            <Table bordered>
                                              <tbody>
                                                <tr>
                                                  <td>id</td>
                                                  <td>
                                                    id
                                                  </td>
                                                  <td>String</td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>name</td>
                                                  <td>
                                                    name
                                                  </td>
                                                  <td>String</td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>englishName</td>
                                                  <td>
                                                    englishName
                                                  </td>
                                                  <td>String</td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </Table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>name</td>
                                          <td>
                                            name
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>englishName</td>
                                          <td>
                                            englishName
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>droppingPoints</td>
                          <td>
                            droppingPoints
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>city</td>
                                  <td>
                                    city
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>terminal</td>
                                  <td>
                                    terminal
                                  </td>
                                  <td>String</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>additionalInfo</td>
                                  <td>
                                    additionalInfo
                                  </td>
                                  <td>Collection of string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>city</td>
                                          <td>
                                            city
                                          </td>
                                          <td>Collection of string</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan={4}>
                                            <Table bordered>
                                              <tbody>
                                                <tr>
                                                  <td>id</td>
                                                  <td>
                                                    id
                                                  </td>
                                                  <td>String</td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>name</td>
                                                  <td>
                                                    name
                                                  </td>
                                                  <td>String</td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>englishName</td>
                                                  <td>
                                                    englishName
                                                  </td>
                                                  <td>String</td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </Table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>name</td>
                                          <td>
                                            name
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>englishName</td>
                                          <td>
                                            englishName
                                          </td>
                                          <td>String</td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>type</td>
                          <td>
                            type
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>price</td>
                          <td>
                            price
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>financial</td>
                          <td>
                            financial
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>price</td>
                                  <td>
                                    price
                                  </td>
                                  <td>Integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>maxApplicableDiscountPercentage</td>
                                  <td>
                                    maxApplicableDiscountPercentage
                                  </td>
                                  <td>Integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>availablePaymentMethods</td>
                                  <td>
                                    availablePaymentMethods
                                  </td>
                                  <td>Collection of string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>commissionPercentage</td>
                                  <td>
                                    commissionPercentage
                                  </td>
                                  <td>Integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                        <tr>
                          <td>departureDate</td>
                          <td>
                            departureDate
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>availableSeates</td>
                          <td>
                            availableSeates
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>status</td>
                          <td>
                            status
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>description</td>
                          <td>
                            description
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>fromCityCode</td>
                          <td>
                            fromCityCode
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>fromCityName</td>
                          <td>
                            fromCityName
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>toCityCode</td>
                          <td>
                            toCityCode
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>toCityName</td>
                          <td>
                            toCityName
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>date</td>
                          <td>
                            date
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>transferCode</td>
                          <td>
                            transferCode
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>imageURL</td>
                          <td>
                            imageURL
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>transferCompanyID</td>
                          <td>
                            transferCompanyID
                          </td>
                          <td>Guid</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(SearchResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default BusSearchPage;